import ClientLogger from 'src/utils/logger';
import { ClientLog } from 'src/constants/clientLog';

/**
 * Formats seconds into a MM:SS format with leading zeros for seconds
 * @param seconds Total duration in seconds
 * @returns Formatted time string in MM:SS format
 * @throws Error if the input is not a number
 */
export const timeConverter = (seconds: number): string => {
// Ensure seconds is number type
  if (typeof seconds !== 'number') {
    const errorMessage = `timeConverter expects a number but received ${typeof seconds} with value: ${seconds}`;
    const error = new Error(errorMessage);
    ClientLogger.error(ClientLog.InputValidationError, error, {
      inputType: typeof seconds,
      inputValue: String(seconds),
      url: window.location.href,
    });
    throw error;
  }

  // Negative check
  if (seconds < 0) {
    const errorMessage = `timeConverter expects a positive number but received ${seconds}`;
    const error = new Error(errorMessage);
    ClientLogger.error(ClientLog.InputValidationError, error, {
      seconds,
      url: window.location.href,
    });
    throw error;
  }

  const roundedSeconds = Math.round(seconds);
  const minutes = Math.floor(roundedSeconds / 60);
  const remainingSeconds = roundedSeconds % 60;
  return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
};
